const DataSocials = [
  {
    id: "fg4858465",
    title: "Instagram",
    link: "https://www.instagram.com/cafesciences/",
    icon: "fa-brands fa-square-instagram",
  },

  {
    id: "gd56gf46",
    title: "BlueSky",
    link: "https://bsky.app/profile/cafe-sciences.org",
    icon: "fa-brands fa-square-bluesky",
  },

  {
    id: "sdf654sf",
    title: "Facebook",
    link: "https://www.facebook.com/cafesciences/",
    icon: "fa-brands fa-square-facebook",
  },

  {
    id: "fds654658",
    title: "Threads",
    link: "https://www.threads.net/@cafesciences",
    icon: "fa-brands fa-square-threads",
  },

  {
    id: "fdg65435",
    title: "Youtube",
    link: "https://www.youtube.com/channel/UCqso49d76__r5PlHRf_b9ZA",
    icon: "fa-brands fa-square-youtube",
  },
];

export default DataSocials;
